// src/components/alertesCritiques/BoutonAlertesCritiques.jsx
// Le bouton « Alertes » de la barre du haut (GO de Daniel du 16/10/2026), à
// gauche de la cloche : il ouvre et ferme le panneau latéral des alertes
// critiques (PanneauLateralAlertes). À monter dans les `children` du
// fournisseur AlertesCritiques : il lit le contexte.
//
// - Sans icône : une pilule texte, h-9 px-3 rounded-lg, comme « Déconnexion ».
// - Pastille rouge avec le nombre restant à traiter ici (compterATraiter, pas
//   le a_traiter brut du serveur : sans les corrections d'une autre année ni
//   les campagnes). Pas de pastille à 0, ni quand le compte n'est plus sûr
//   (résumé de plus de deux intervalles, ou d'une autre année).
// - Pressé quand le panneau est ouvert : fond blanc, texte #246990.
// - Caché en année clôturée (actif = false) et pour un agent qui n'a aucun
//   détecteur ouvert (résumé du serveur, detecteurs_ouverts).
// - Pas d'infobulle : l'aria-label dit tout (« Alertes critiques - 3 à traiter »).

import React from 'react';
import { useAlertesCritiquesContexte } from './AlertesCritiques';
import { ID_PANNEAU_LATERAL } from './useAlertesCritiques';

const BASE = 'inline-flex h-9 flex-shrink-0 items-center gap-2 whitespace-nowrap rounded-lg px-3 text-sm font-semibold '
  + 'transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/70';
const REPOS = 'bg-white/10 text-white hover:bg-white/20';
const PRESSE = 'bg-white text-[#246990]';

export default function BoutonAlertesCritiques({ className = '' }) {
  const { actif, boutonVisible, compteBouton, panneauOuvert, basculerPanneau } = useAlertesCritiquesContexte();
  if (!actif || !boutonVisible) return null;

  const connu = typeof compteBouton === 'number' && Number.isFinite(compteBouton);
  const compte = connu && compteBouton > 0 ? compteBouton : 0;
  const libelle = connu ? `Alertes critiques - ${compteBouton} à traiter` : 'Alertes critiques';

  return (
    <button
      type="button"
      onClick={basculerPanneau}
      aria-expanded={Boolean(panneauOuvert)}
      aria-controls={ID_PANNEAU_LATERAL}
      aria-label={libelle}
      className={`${BASE} ${panneauOuvert ? PRESSE : REPOS}${className ? ` ${className}` : ''}`}
    >
      <span>Alertes</span>
      {compte > 0 && (
        <span
          aria-hidden="true"
          className="inline-flex h-5 min-w-[20px] items-center justify-center rounded-lg bg-red-500 px-1 text-xs font-bold text-white"
        >
          {compte > 99 ? '99+' : compte}
        </span>
      )}
    </button>
  );
}
